import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { HelpDialogComponent } from './help-dialog/help-dialog.component';
import { HelpService } from 'src/app/services/help/help.service';

@Component({
  selector: 'app-help-button',
  templateUrl: './help-button.component.html',
  styleUrls: ['./help-button.component.scss']
})
export class HelpButtonComponent implements OnInit, OnChanges {
  @Input() helpId: number = 0;
  private dialogId(): string {
    return 'help-dialog-'.concat(this.helpId.toString());
  }
  public fullPath: string = "";
  private dialogRef: MatDialogRef<any> | undefined = undefined;
  constructor(
    private dialog: MatDialog,
    private helpService: HelpService
  ) { }

  async ngOnInit(): Promise<void> {
    this.fullPath = await this.helpService.getHelpPageFullPath(this.helpId);
  }

  async ngOnChanges(changes: any) {
    if (changes['helpId'] && changes['helpId'].currentValue !== changes['helpId'].previousValue) {
      this.fullPath = await this.helpService.getHelpPageFullPath(this.helpId);
    }
  }

  public onClick() {
    if (this.dialogRef?.getState() == MatDialogState.OPEN)
      return;

    if (this.helpService.previousHelpId > 0)
      this.dialog.getDialogById("help-dialog" + this.helpService.previousHelpId.toString())?.close();

    this.dialogRef = this.dialog.open(HelpDialogComponent, <MatDialogConfig>{
      id: "help-dialog" + this.helpId.toString(),
      hasBackdrop: false,
      disableClose: true,
      height: "100%",
      width: "400px",
      panelClass: "help-dialog",
      position: { right: "0px" },
      data: this.fullPath
    });
    
    this.helpService.previousHelpId = this.helpId;
    this.helpService.postClickedHelp(this.helpId);
  }

}
